var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "referrals-accured-written-off-cell",
      class: {
        "referrals-accured-written-off-cell-red": _vm.cellValue < 0,
        "referrals-accured-written-off-cell-green": _vm.cellValue > 0,
        "referrals-accured-written-off-cell-black": _vm.cellValue === 0,
      },
    },
    [_vm._v(" " + _vm._s(_vm.numberWithSpaces(_vm.cellValue)) + " ")]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }